import { codeIndexStatusBadgeClass, getStatusPillClass } from './statusPillClasses';

/**
 * @param {{ codeIndexStatus?: string, codeIndexStage?: string | null } | null | undefined} repo
 */
export function isCodeIndexInProgress(repo) {
  if (!repo) return false;
  if (repo.codeIndexStatus === 'running') return true;
  return repo.codeIndexStatus === 'pending' && repo.codeIndexStage === 'queued';
}

/**
 * @param {string | null | undefined} stage
 */
export function formatCodeIndexStageLabel(stage) {
  const map = {
    queued: 'Queued',
    cloning: 'Cloning repository',
    chunking: 'Reading files',
    embedding: 'Embedding',
    persisting: 'Saving to database',
  };
  if (stage && map[stage]) return map[stage];
  if (stage) return String(stage);
  return 'Starting…';
}

/**
 * @param {string | undefined} status
 * @param {string | null | undefined} stage
 */
export function formatCodeIndexStatusLabel(status, stage) {
  if (status === 'success') return 'Indexed';
  if (status === 'failed') return 'Failed';
  if (status === 'pending' && stage === 'queued') return 'Queued';
  if (status === 'running') return 'Indexing…';
  if (status === 'pending') return 'Pending';
  return status || 'Unknown';
}

export { codeIndexStatusBadgeClass };

/**
 * @param {{ codeIndexStatus?: string, codeIndexStage?: string | null } | null | undefined} repo
 */
export function codeIndexStatusBadgeClassForRepo(repo) {
  if (isCodeIndexInProgress(repo)) return getStatusPillClass('sky');
  return codeIndexStatusBadgeClass(repo?.codeIndexStatus || '');
}
